
export class FranchiseCentralTenantInfo {
  tenantID: number;
  alias: string;
  isActive: boolean;
  name: string;
};